import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '@src/utils/constants';

export type RideType =
  | 'lyft'
  | 'lyft_access'
  | 'lyft_assisted'
  | 'lyft_lux'
  | 'lyft_luxsuv'
  | 'lyft_plus'
  | 'lyft_premier'
  | 'lyft_priority_pickup'
  | 'lyft_wait_and_save';

type DriverAvailableParamsType = {
  origin_address: string;
  origin_lat: number;
  origin_lng: number;
  dest_lat?: number;
  dest_lng?: number;
  origin_state?: string;
  pickup_time_ms: number;
  dispatch_type: 'flex' | 'scheduled';
  contractorType: 'uber' | 'lyft' | 'other';
};

type DriverAvailabilityResponseType = {
  driver_availability_predictions: [
    {
      origin: {
        address: string;
        latitude: number;
        longitude: number;
      };
      pickup_time_ms: number;
      ride_type: string;
      dispatch_type: 'flex' | 'scheduled';
      driver_availability_level: 'GREEN' | 'RED' | 'YELLOW';
      driver_availability_token: string;
    },
  ];
};

export const conciergeApi = createApi({
  reducerPath: 'Concierge',
  tagTypes: ['Concierge'],
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    credentials: 'include',
    prepareHeaders: (headers) => headers,
  }),
  endpoints: (builder) => ({
    getDriverAvailability: builder.query<
      DriverAvailabilityResponseType,
      DriverAvailableParamsType
    >({
      query: (queryParams) => {
        const { contractorType, ...restParams } = queryParams;
        return {
          url: `/${queryParams.contractorType}/concierge/driver-availability`,
          method: 'GET',
          params: restParams,
        };
      },
    }),
  }),
});

export const { useLazyGetDriverAvailabilityQuery } = conciergeApi;
